// TODO: Rename to something more fitting

// TODO: Merge business middleware into this one

export default defineNuxtRouteMiddleware(to => {
  const directSignStore = useDirectSignStore()

  // NAS will never be locked out of anything
  if (directSignStore.isDirectSign) return

  const businessStore = useBusinessStore()
  const userStore = useUserStore()

  const {
    $i18n: { t },
  } = useNuxtApp()

  const { userRepository } = useApi()
  const { logError } = useErrorHandling()

  if (userStore.attributes.weakPassword && to.name !== 'profile-change-password') {
    return navigateTo({ name: 'profile-change-password' })
  }

  const { isBusinessMember, isBusinessAdmin } = storeToRefs(userStore)
  const { createSnackbar, setDialog } = useWidgetStore()

  if (businessStore.id) {
    if (!userStore.attributes.acceptedBusinessInvite) {
      setDialog('business/DialogBusinessInvitation', { businessName: businessStore.name }, async () => {
        await userStore.accept('biz')
        await userStore.fetchUser()
      })
      return
    }
    if (
      (businessStore.isTrialExpired || businessStore.isLocked) &&
      isBusinessAdmin.value &&
      !['business-members', 'business-upgrade', 'logout'].includes((to.name as string) ?? '')
    ) {
      return navigateTo('/business/members')
    } else if (
      (businessStore.isTrialExpired || businessStore.isLocked) &&
      isBusinessMember.value &&
      !isBusinessAdmin.value
    ) {
      setDialog('business/DialogBusinessLockedMember', {})
    } else if (businessStore.isStarterPlan && !businessStore.isGtcAccepted) {
      // When business that is in Chargebee Trial is migrated back to Starter plan,
      // then all its members are migrated to their own new businesses with Starter plan
      // and now they need to accept GTC for the new business.
      setDialog('business/DialogMigratedToStarter', {}, async () => {
        await businessStore.acceptGtc()
        await navigateTo({ name: 'index' })
      })
    }
  } else if (
    !userStore.attributes.acceptedGtc &&
    !userStore.attributes.businessDeleted &&
    !userStore.isSsoSetupIncomplete
  ) {
    setDialog('DialogAcceptTerms', {}, async () => {
      await userStore.accept('gtc')
      // FIXME: On unlinking users, the backend sets ALL attributes to `true` that we could use to distinguish different
      // unlinking reasons. We need to fix that by prioritising this `else if` clause and overriding the attributes.
      if (userStore.attributes.removedFromBusiness) {
        await userRepository.updateAttributes({
          removedFromBusiness: false,
        })
      }
      await userStore.fetchUser()
    })
  } else if (userStore.attributes.removedFromBusiness || userStore.attributes.businessDeleted) {
    setDialog('business/DialogBusinessDowngraded', { isAdmin: userStore.attributes.businessDeleted }, async () => {
      try {
        await userStore.accept('gtc')
        await userRepository.updateAttributes({
          removedFromBusiness: false,
          businessDeleted: false,
        })
        await userStore.fetchUser()
        await navigateTo({ name: 'index' })
      } catch (error) {
        logError('Failed to downgrade business', error)
        createSnackbar({
          message: t('global.error.generic_support'),
        })
      }
    })
  }
})
